import { create } from 'zustand';
import { AuthModalContentIds } from '../../templates/AuthModal/logic';

type State = {
    isVisibleAuthModal: boolean;
    page: AuthModalContentIds;
};

type Action = {
    setIsVisibleAuthModal: (isVisibleAuthModal: boolean, page?: AuthModalContentIds) => void;
    setPage: (page: AuthModalContentIds) => void;
};

export const useModalAuthStore = create<State & Action>(set => ({
    isVisibleAuthModal: false,
    page: 'login',
    setPage: (page) => {
        set(() => ({
            page,
        }))
    },
    setIsVisibleAuthModal: (isVisibleAuthModal, page) => {
        set(() => ({
            isVisibleAuthModal,
            page
        }));
    },
}));
